import React from 'react'
import styles from './filters.module.scss'
import { Tag } from 'components'
import { wrapTags } from '../../utils/regex'
const Text = require(`../../services/${process.env.REACT_APP_BRAND}/text/text.json`)

function Filters({ filters, handleClick, handleClickRemoveTag, price }) {
  function renderAppliedFilters() {
    return filters.map((item, index) => (
      <Tag
        key={index}
        icon={item.icon}
        type="multiple"
        handleClick={handleClickRemoveTag}
        name={item.name}
        value={item.value}
        checked={true}
        price={price}
      >
        {item.value}
      </Tag>
    ))
  }
  return (
    <div className={styles.filters}>
      <div className={styles.filters_container}>
        <div className={styles.filters__column}>
          <div className={styles.filters__container_phrase}>
            <strong className={styles.filters__phrase}>{Text.filterText}</strong>
          </div>
          <div className={styles.filters__tags}>
            <div className={styles.filters__scroll}>
              {filters.length > 0 && renderAppliedFilters()}
            </div>
          </div>
        </div>

        <div className={styles.filters__column}>
          <div className={styles.filters__banner}>
            <h2>
              { wrapTags(Text.restartMessage, 'bold').map(item => item) }
            </h2>
            <button
              className={`ty-button ${styles.filters__restartButton}`}
              onClick={handleClick}
            >
              {Text.restartButton}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export { Filters }
